import api from 'api/api'

export const GET_DEPARTMENTS = '[TERRITORIAL DIVISION] GET DEPARTMENTS'
export const GET_PROVINCES_BY_DEPARTMENT_ID = '[TERRITORIAL DIVISION] GET PROVINCES BY DEPARTMENT ID'
export const GET_DISTRICTS_BY_PROVINCE_ID = '[TERRITORIAL DIVISION] GET DISTRICTS BY PROVINCE ID'

export function getDepartmentsAction() {
  const request = api.get('/territorial-division/departments')
  return (dispatch) => {
    dispatch({ type: GET_DEPARTMENTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_DEPARTMENTS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_DEPARTMENTS, error)
    }).finally(() => {
      dispatch({ type: GET_DEPARTMENTS, payload: { loading: false } })
    })
  }
}

export function getProvincesByDepartmentIdAction(departmentId) {
  const request = api.get(`/territorial-division/provinces/${departmentId}`)
  return (dispatch) => {
    dispatch({ type: GET_PROVINCES_BY_DEPARTMENT_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PROVINCES_BY_DEPARTMENT_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_PROVINCES_BY_DEPARTMENT_ID, error)
    }).finally(() => {
      dispatch({ type: GET_PROVINCES_BY_DEPARTMENT_ID, payload: { loading: false } })
    })
  }
}

export function getDistrictsByProvinceIdAction(provinceId) {
  const request = api.get(`/territorial-division/districts/${provinceId}`)
  return (dispatch) => {
    dispatch({ type: GET_DISTRICTS_BY_PROVINCE_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_DISTRICTS_BY_PROVINCE_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_DISTRICTS_BY_PROVINCE_ID, error)
    }).finally(() => {
      dispatch({ type: GET_DISTRICTS_BY_PROVINCE_ID, payload: { loading: false } })
    })
  }
}
